<template>
    <div>
        <EditorBlock title="Background Image" :block="block">
            <label>Background Image URL</label>
            <input class="form-control" type='text' v-model="block.bgImage" @keyup="$emit('update:block', block);" />
        </EditorBlock>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        min-height: 2.5rem;
    }
</style>

<script>
import EditorBlock from "@/components/dashboard/storeadmin/EditorBlock";
export default {
    data: () => ({
        editor: null
    }),
    props: ['block'],
    components: {
        EditorBlock

    },
    methods: {

    },
    mounted () {

    }
}
</script>
